module.exports = __webpack_public_path__ + "img/right3.bc9361e6.png";